<template>
	<Icon v-bind="$props">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
			<path
				class="light"
				fill="currentColor"
				d="M336 192C327.2 192 320 199.2 320 208V256c0 73.5-62.25 132.6-136.8 127.8C115.3 379.1 64 319.6 64 251.5V208C64 199.2 56.8 192 48 192S32 199.2 32 208v42.38c0 83.38 61.63 156.1 144 164.4V480h-64C103.2 480 96 487.2 96 496C96 504.8 103.2 512 112 512h160c8.801 0 16-7.201 16-16c0-8.801-7.199-16-16-16h-64v-65C288.8 406.9 352 338.8 352 256V208C352 199.2 344.8 192 336 192zM192 352c53 0 96-43 96-96v-160c0-52.1-43-96-96-96s-96 43-96 96v160C96 309 139 352 192 352zM128 96c0-35.25 28.75-64 64-64s64 28.75 64 64v160c0 35.25-28.75 64-64 64S128 291.3 128 256V96z"
			/>
			<path
				class="regular"
				fill="currentColor"
				d="M344 192C330.7 192 320 202.7 320 215.1V256c0 74.75-64.5 134.9-140.8 127.4C112.8 376.9 64 317.1 64 250.2V215.1C64 202.7 53.25 192 40 192S16 202.7 16 215.1v32.15c0 89.63 64 169.6 152 181.7V464H119.1C106.7 464 96 474.7 96 487.1S106.7 512 119.1 512h144C277.3 512 288 501.3 288 488S277.3 464 264 464H216v-33.77C301.8 418.5 368 344.9 368 256V215.1C368 202.7 357.3 192 344 192zM192 352c53 0 96-43 96-96v-160c0-52.1-43-96-96-96s-96 43-96 96v160C96 309 139 352 192 352zM144 96c0-26.5 21.5-48 48-48s48 21.5 48 48v160c0 26.5-21.5 48-48 48S144 282.5 144 256V96z"
			/>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'MicrophoneIcon',
	components: { Icon },
	props,
}
</script>
